import { dateUtils, type Optional } from '@festina-life/core'
import dayjs from 'dayjs'

export const beforeEarliestFromDate = (fromDate: Optional<Date>) => {
  if (!fromDate) {
    return undefined
  }

  return dayjs(fromDate).subtract(1, 'day').toDate()
}

export const fromDateAsLocalDate = (fromDate: Optional<string>) =>
  fromDate ? dateUtils.dateUtcAsLocal(fromDate).toDate() : undefined
